<template>
  <div class="articlemanagement">
    <Row type="flex" justify="center" align="top" class="code-row-bg">
      <Col span="14">
      <Card :style="'margin-right: 5px;height:' + (height + 120) + 'px'">
        <!--:is="defaultMap"-->
        <component is="leaflet" :areaColor="areaColorList" :addNode="addNode" :stationId="taskData.stationId" ref="mapCase" @updateNodeList="updateNodeList">
          <div class="leaflet" :style="'height:' + (height + 90) + 'px'">
            <div id="task_map_id" ref="map" class="map"></div>
            <Spin v-show="mapLoading" fix>
                <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
                <div>{{ langMap.loading[lang] }}</div>
            </Spin>
          </div>
        </component>
      </Card>
      </Col>
      <!--右侧表格-->
      <Col span="10">
      <div class="nodeArea">
        <Card :bordered="false">
          <div slot="title">
            <Row>
              <Col :xs="24" :sm="24">
              <Form :label-width="80">
                <div class="des-cardTittle-box">
                  <h3>{{ this.taskData.name }}-{{ langMap.pathPlanning[lang] }}</h3>
                  <div>
                    <Button type="primary" style="margin-left:10px;" @click="modelShow(true, null)">{{ langMap.addNode[lang] }}</Button>
                    <Button v-if="selectedNodes.length > 0" type="error" style="margin-left:10px;" @click="batchDelete">{{ langMap.delete[lang] }} ({{ selectedNodes.length }})</Button>
                    <Button type="primary" style="margin-left:10px;" @click="saveTask()">{{ langMap.save[lang] }}</Button>
                    <Button style="margin-left:10px;" @click="backPage()">{{ langMap.back[lang] }}</Button>
                  </div>
                </div>
              </Form>
              </Col>
            </Row>
          </div>
          <div class="table-container" :style="'height:' + height + 'px; overflow-y: auto; border: 1px solid #dcdee2; position: relative;'">
            <!-- Loading -->
            <Spin fix v-if="tableLoading">
              <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
              <div>{{ langMap.loading[lang] }}</div>
            </Spin>
            
            <!-- 表头 -->
            <div class="custom-header">
               <div class="c-col-checkbox">
                  <Checkbox v-model="selectAll" @on-change="toggleSelectAll"></Checkbox>
               </div>
               <div class="c-col-order">#</div>
               <div class="c-col-name">{{ langMap.name[lang] }}</div>
               <!-- <div class="c-col-type">{{ langMap.type[lang] }}</div> -->
               <div class="c-col-oper">{{ langMap.operation[lang] }}</div>
            </div>

            <!-- 数据列表 -->
            <div class="custom-body">
               <div v-if="nodeList.length === 0" class="no-data">{{ langMap.empty[lang] }}</div>
               <div v-for="(item, index) in nodeList" :key="index">
                  <!-- 节点行 -->
                  <div class="custom-row" @click="rowClick(item)">
                     <div class="c-col-checkbox" @click.stop>
                        <Checkbox v-if="index > 0 && index < nodeList.length - 1" v-model="item.checked" @on-change="onCheckChange"></Checkbox>
                     </div>
                     <div class="c-col-order">{{ item.nodeOrder }}</div>
                     <div class="c-col-name" :title="item.name">{{ item.name }}</div>
                     <!-- <div class="c-col-type">{{ getTypeName(item.type) }}</div> -->
                     <div class="c-col-oper">
                        <!-- 修改 -->
                        <Tooltip :content="langMap.modify[lang]" placement="top" transfer>
                           <Button type="text" icon="md-create" size="small" style="color:#2d8cf0;font-size:20px;" @click.stop="modelShow(true, item)"></Button>
                        </Tooltip>
                        <!-- 删除 (非起终点) -->
                        <Tooltip v-if="![1,2].includes(item.mode)" :content="langMap.delete[lang]" placement="top" transfer>
                           <Button type="text" icon="md-trash" size="small" style="color:#ed4014;font-size:20px;" @click.stop="confirmDel(item)"></Button>
                        </Tooltip>
                        <!-- 标记 (无坐标) -->
                        <Tooltip v-if="!item.lat && !item.lng" :content="langMap.mark[lang]" placement="top" transfer>
                           <Button type="text" icon="md-pin" size="small" style="color:#ff9900;font-size:20px;" @click.stop="addMarker(item)"></Button>
                        </Tooltip>
                     </div>
                  </div>
                  
                  <!-- 行間插入条: 直观昺示在两个节点之间，但终止节点后不昺示 -->
                  <div v-if="item.mode !== 2" class="insert-bar" @click.stop="modelShow(true, null, index + 1)">
                     <div class="insert-line"></div>
                     <div class="insert-content">
                        <!-- 距离信息（仅当有效时昺示） -->
                        <div v-if="index < nodeList.length - 1 && distanceArray && distanceArray[index] !== undefined" class="distance-display">
                           <span class="distance-text-inline">{{ langMap.refDistance[lang] }}: {{ getDistanceText(index) }}</span>
                        </div>
                        <!-- 插入按钮 -->
                        <div class="insert-btn">
                           <Icon type="md-add-circle" /> {{ langMap.insert[lang] }}
                        </div>
                     </div>
                     <div class="insert-line"></div>
                  </div>
               </div>
            </div>
          </div>
        </Card>

        <Modal :mask-closable="false" v-model="saveModal" :title="langMap.jobNode[lang]">
          <Form ref="formValidate" :model="saveForm" :rules="ruleValidate" :label-width="120">
            <FormItem :label="langMap.name[lang]" prop="name">
              <Input v-model="saveForm.name" :placeholder="langMap.inputName[lang]" clearable />
            </FormItem>
            <!-- <FormItem :label="langMap.type[lang]" class="leftFlex" prop="type">
              <Select v-model="saveForm.type">
                <Option :key="item.id" :value="item.id" v-for="item in nodeTypeList">{{ item.name }}</Option>
              </Select>
            </FormItem> -->
            <FormItem :label="langMap.wgs84Coordinate[lang]">
              <Row :gutter="10">
                <Col span="12">
                  <FormItem prop="wgs84Lng" :label-width="0">
                    <Input v-model="saveForm.wgs84Lng" :placeholder="langMap.longitude[lang]" clearable @input="limitDecimalPlaces('wgs84Lng', 7)" />
                  </FormItem>
                </Col>
                <Col span="12">
                  <FormItem prop="wgs84Lat" :label-width="0">
                    <Input v-model="saveForm.wgs84Lat" :placeholder="langMap.latitude[lang]" clearable @input="limitDecimalPlaces('wgs84Lat', 7)" />
                  </FormItem>
                </Col>
              </Row>
            </FormItem>
            <DynamicForm
              ref="dynamicForm"
              v-model="saveForm.attrs"
              :configKey="formConfigKey"
            />
            <FormItem :label="langMap.description[lang]">
              <Input v-model="saveForm.description" type="textarea" clearable :autosize="{ minRows: 4, maxRows: 8 }"
                :placeholder="langMap.descInfo[lang]" />
            </FormItem>
          </Form>
          <div slot="footer">
            <Button type="text" :loading="btnLoading" @click="cancel">{{ langMap.cancel[lang] }}</Button>
            <Button type="primary" :loading="btnLoading" @click="saveNode">{{ langMap.save[lang] }}</Button>
          </div>
        </Modal>
      </div>
      </Col>
    </Row>
  </div>
</template>
<script>
import leaflet from './mapUnit/leaflet.vue';
import { getItem } from '@/utils/mapUtil.js';
import { v4 as uuidv4 } from 'uuid';
import api from "../../../api";
import langMap from '@/utils/language';
import { mapState } from 'vuex';
import DynamicForm from '@/components/DynamicForm/index.vue'
import { getDistanceArray, calculateTotalDistance, formatDistance } from '@/utils/coordinateUtil.js'
let mapCase = null;

function addNode(arr, node) {
  //const [item, ix] = getItem(arr, node.id, 'id');
  //if (ix >= 0) return console.warn('[APP WARN] addNode:已存在目标元素');
  // 导数第2位插入节点
  const len = arr.length;
  arr.splice(len - 1, 0, node);
  node.nodeOrder = len;
  // 更新最后1个点的顺序
  arr[arr.length - 1].nodeOrder = arr.length;
}

export default {
  name: 'TaskPlan',
  props: [
    'taskData'
  ],
  components: { leaflet, DynamicForm },
  data() {
    return {
      langMap:langMap,
      placeSearch: null,

      height: (document.documentElement.clientHeight - 260),

      map: null,
      line: null,
      currentMarker: null,
      markers: [],
      nodeTypeList: [],
      mapLoading: true, // 地图加载状态
      pathId: this.taskData.id,
      btnLoading: false,
      saveModal: false,
      nodeList: [],
      insertIndex: -1, // 插入位置索引
      tableLoading: true, // 表格加载状态
      selectedNodes: [], // 选中的节点
      selectAll: false, // 全选状态
      distanceArray: [], // 节点间距离数组
      totalDistance: 0, // 总距离
      saveForm: {
        id: null,
        tempId: null,
        nodeOrder: '',
        name: '',
        type: 0,
        typeStr: '',
        pathId: null,
        coordinateType: 'WGS',
        lat: null,
        lng: null,
        wgs84Lat: null,
        wgs84Lng: null,
        coordinateSource: null, // 'map' or 'form'
        description: '',
        attrs: null
      },
      addNode: addNode,
      formConfigKey: 'homeworkNodeMap' // 只保留配置参数名
    }
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
      areaColorList: state => state.app.mapAreaColor
    }),
    ruleValidate(){
      const validateNumber = (rule, value, callback) => {
        // 非必填，仅当有值时验证
        if (value === '' || value === null || value === undefined) {
          callback();
        } else if (isNaN(value)) {
          callback(new Error(langMap.mustBeNumber[this.lang]));
        } else {
          const num = parseFloat(value);
          if (num < -180 || num > 180) {
            callback(new Error(langMap.coordinateRangeError[this.lang]));
          } else {
            callback();
          }
        }
      };
      return {
        name: [
          { required: true, message: langMap.nameRequired[this.lang], trigger: 'blur' }
        ],
        wgs84Lng: [
          { validator: validateNumber, trigger: 'blur' }
        ],
        wgs84Lat: [
          { validator: validateNumber, trigger: 'blur' }
        ]
      }
    },
    col(){
      return [
      {
          title: '',
          key: 'nodeOrder',
          width: 60,
        },
        {
          title: langMap.name[this.lang],
          key: 'name',
        },
        {
          title: langMap.type[this.lang],
          key: 'type',
          render: (h, { row }) => {
            let text = row.type;
            this.nodeTypeList.forEach((item, index, arr) => {
              if (item.id == row.type) {
                text = item.name;
              }
            })
            return h("span", text);
          }
        },
        {
          title: langMap.operation[this.lang],
          align: 'center',
          width: 180,
          render: (h, params) => {
            const createBtn = (icon, color, text, clickFn) => {
              return h('Tooltip', {
                props: {
                  content: text,
                  placement: 'top',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'text',
                    icon: icon,
                    size: 'small'
                  },
                  style: {
                    color: color,
                    fontSize: '20px',
                    padding: '0 5px',
                    margin: '0 2px'
                  },
                  on: {
                    click: ($e) => {
                      $e.stopPropagation();
                      clickFn();
                    }
                  }
                })
              ])
            };

            var renderArray = [];
            
            // 编辑
            renderArray.push(createBtn('md-create', '#2d8cf0', this.langMap.modify[this.lang], () => {
              this.modelShow(true, params.row);
            }));

            // 插入 (Insert)
            renderArray.push(createBtn('md-arrow-down', '#19be6b', this.langMap.insert[this.lang], () => {
               // 插入节点
               this.modelShow(true, null, params.index + 1);
            }));

            // 删除: 起点终点(mode 1, 2)不可删除
            if (![1, 2].includes(params.row.mode)) {
               renderArray.push(createBtn('md-trash', '#ed4014', this.langMap.delete[this.lang], () => {
                  this.$Modal.confirm({
                    title: this.langMap.systemTip[this.lang],
                    content: this.langMap.confirmDelete[this.lang],
                    okText: langMap.confirm[this.lang],
                    cancelText: langMap.cancel[this.lang],
                    onOk: () => {
                      this.delMarker(params.row);
                    }
                  });
               }));
            }

            // 标记: 无坐标时显示
            if (params.row.lat === null || params.row.lat === '' || params.row.lng === null || params.row.lng === '') {
               renderArray.push(createBtn('md-pin', '#ff9900', this.langMap.mark[this.lang], () => {
                  this.addMarker(params.row);
               }));
            }

            return h("div", {
              style: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }
            }, renderArray);
          }
        }
      ]
    }
  },
  methods: {
    // 限制小数点位数
    limitDecimalPlaces(field, places) {
      const value = this.saveForm[field];
      if (!value) return;
      
      const parts = value.toString().split('.');
      if (parts.length === 2 && parts[1].length > places) {
        this.saveForm[field] = parseFloat(parts[0] + '.' + parts[1].substring(0, places));
      }
    },
    // 四舍五入到指定小数位数
    roundDecimal(num, places) {
      if (typeof num !== 'number') return num;
      return parseFloat(num.toFixed(places));
    },
    // 截取小数指定位数
    truncateDecimal(num, places) {
      if (typeof num !== 'number') return num;
      const factor = Math.pow(10, places);
      return Math.trunc(num * factor) / factor;
    },
    getTypeName(typeId) {
       let name = typeId;
       this.nodeTypeList.forEach(item => {
         if (item.id == typeId) name = item.name;
       });
       return name;
    },
    // 更新距离数组
    updateDistances() {
      this.distanceArray = getDistanceArray(this.nodeList);
      this.totalDistance = calculateTotalDistance(this.nodeList, false); // false表示使用米为单位
    },
    // 获取两个节点之间的距离文字描述
    getDistanceText(index) {
      if (!this.distanceArray || this.distanceArray[index] === undefined) {
        return '-';
      }
      if (this.distanceArray[index] === 0) {
        return this.langMap.noCoordinateData[this.lang];
      }
      return formatDistance(this.distanceArray[index], false);
    },
    // 複選框状态變化
    onCheckChange() {
      // 过滤出不是第一个和最后一个节点的已选中节点
      this.selectedNodes = this.nodeList.filter((item, index) => {
        return item.checked && index > 0 && index < this.nodeList.length - 1;
      });
      // 计算可以选择的节点数（验餙第一个和最后一个）
      const selectableNodes = this.nodeList.filter((item, index) => index > 0 && index < this.nodeList.length - 1);
      // 如果全部可选节点都选中，则全选框为true
      this.selectAll = selectableNodes.length > 0 && this.selectedNodes.length === selectableNodes.length;
    },
    // 全选/取消全选
    toggleSelectAll(val) {
      this.nodeList.forEach((item, index) => {
        // 只对验餙第一个和最后一个节点的截客设置
        if (index > 0 && index < this.nodeList.length - 1) {
          item.checked = val;
        }
      });
      this.onCheckChange();
    },
    // 批量删除
    batchDelete() {
      if (this.selectedNodes.length === 0) {
        this.$Notice.warning({
          title: this.langMap.tip[this.lang],
          desc: this.langMap.pleaseSelectNodesToDelete[this.lang]
        });
        return;
      }
      
      this.$Modal.confirm({
        title: this.langMap.systemTip[this.lang],
        content: `确定删除选中的 ${this.selectedNodes.length} 个节点吗？`,
        okText: this.langMap.confirm[this.lang],
        cancelText: this.langMap.cancel[this.lang],
        onOk: () => {
          // 获取要删除的节点数量（在清除前不然就是0了）
          const deleteCount = this.selectedNodes.length;
          // 获取要删除的节点的tempId或id
          const deleteIds = this.selectedNodes.map(item => item.tempId || item.id);
          
          // 过滤出不需要删除的节点
          this.nodeList = this.nodeList.filter(item => {
            return !deleteIds.includes(item.tempId || item.id);
          });
          
          // 重新排序
          this.nodeList.forEach((item, index) => {
            item.nodeOrder = index + 1;
          });
          
          // 删除地图上的marker
          deleteIds.forEach(id => {
            const deletedNode = this.selectedNodes.find(n => (n.tempId || n.id) === id);
            if (deletedNode && mapCase) {
              mapCase.delMarker(deletedNode);
            }
          });
          
          // 清除选中状态
          this.selectedNodes = [];
          this.selectAll = false;
          
          // 更新距离数据
          this.updateDistances();
          
          this.$Notice.success({
            title: this.langMap.tip[this.lang],
            desc: `${this.langMap.removedFromList[this.lang]} ${deleteCount} ${this.langMap.nodeCounts[this.lang]}，${this.langMap.clickSaveButtonToConfirmDelete[this.lang]}`
          });
        }
      });
    },
    // 更新距离数组
    updateDistances() {
      this.distanceArray = getDistanceArray(this.nodeList);
      this.totalDistance = calculateTotalDistance(this.nodeList, false); // false表示使用米为单位
    },
    // 获取两个节点之间的距离文字描述
    getDistanceText(index) {
      if (!this.distanceArray || this.distanceArray[index] === undefined) {
        return '-';
      }
      // if (this.distanceArray[index] === 0) {
      //   return this.langMap.noCoordinateData[this.lang];
      // }
      return formatDistance(this.distanceArray[index], false);
    },
    confirmDel(row) {
        this.$Modal.confirm({
          title: this.langMap.systemTip[this.lang],
          content: this.langMap.confirmDelete[this.lang],
          okText: this.langMap.confirm[this.lang],
          cancelText: this.langMap.cancel[this.lang],
          onOk: () => {
            this.delMarker(row);
            // 单个删除也需要提示仅在15个节点
            this.$Notice.success({
              title: this.langMap.tip[this.lang],
              desc: `${this.langMap.removedFromList[this.lang]} 1 ${this.langMap.nodeCounts[this.lang]}，${this.langMap.clickSaveButtonToConfirmDelete[this.lang]}`
            });
          }
        });
    },
    //初始化地图
    async initMap() {
      mapCase = this.$refs.mapCase;
      await mapCase.initMap();
      this.$nextTick(() => {
        this.mapLoading = false;
      });
      // 确保先绘制区域
      await this.loadAreas();
      //加载路径
      this.loadPath(this.taskData.id);
    },
    //加载现有区域
    loadAreas() {
      return api.getData("task-server/fence/list", this).then(res => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg
          });
        } else {
          if (res.data && res.data.length > 0) {
            //this.areaList = res.data;
            // 区域绘制
            mapCase.initTargetArea(res.data);
            // 移动数据中心点
            const area1 = JSON.parse(res.data[0].area);
            const _point = area1.length && area1[0];
            mapCase.moveToCenter([parseFloat(_point.lon), parseFloat(_point.lat)]);
          }
        }
      });
    },
    rowClick(data) {
      mapCase.createPopup(data.tempId);
    },
    //点击按钮添标记点，每次追加
    addMarker(row) {
      mapCase.addMarker(row, this.nodeList);
    },
    //删除节点
    delMarker(row) {
      mapCase.delMarker(row);
    },
    // 打卡新增或编辑
    async modelShow(flag, data, insertIndex = -1) {
      this.insertIndex = insertIndex;
      if (data) {
        this.saveForm = { ...data };
        // 如果是弟一次打开，需要清除改需的坐标来源标记
        if (!data.id) {
          this.saveForm.coordinateSource = null;
        }
        
        // 编辑时如果没有WGS84坐标但有GCJ02坐标，需要自动转换学填充
        if ((!this.saveForm.wgs84Lat || !this.saveForm.wgs84Lng) && this.saveForm.lat && this.saveForm.lng) {
          try {
            const res = await api.postData(
              `task-server/coordinate/gcj02ToWgs84`,
              { longitude: parseFloat(this.saveForm.lng), latitude: parseFloat(this.saveForm.lat) },
              this
            );
            if (res.success && res.data) {
              this.saveForm.wgs84Lng = this.roundDecimal(res.data[0], 7);
              this.saveForm.wgs84Lat = this.roundDecimal(res.data[1], 7);
            }
          } catch (error) {
            console.error('自动转换WGS84坐标失败', error);
          }
        }
        
        // 编辑时四舍五入已有的WGS84坐标数据以显示
        if (this.saveForm.wgs84Lng) {
          this.saveForm.wgs84Lng = this.roundDecimal(this.saveForm.wgs84Lng, 7);
        }
        if (this.saveForm.wgs84Lat) {
          this.saveForm.wgs84Lat = this.roundDecimal(this.saveForm.wgs84Lat, 7);
        }
      } else {
        this.saveForm = {
          id: null,
          tempId: null,
          nodeOrder: '',
          name: '',
          type: 0,
          typeStr: '',
          pathId: null,
          coordinateType: 'WGS',
          lat: null,
          lng: null,
          wgs84Lat: null,
          wgs84Lng: null,
          coordinateSource: null,
          description: '',
          attrs: null
        }
      }
      this.btnLoading = false;
      this.saveModal = flag;
    },
    //保存节点（新增或编辑）
    async saveNode() {
      const _nodeList = this.nodeList;
      const _saveForm = this.saveForm;
      this.$refs['formValidate'].validate(async(valid) => {
        if (valid) {
          try {
            // 需要墩剥的开启按钮
            this.btnLoading = true;
            
            _saveForm.attrs = await this.$refs.dynamicForm.validate();
            this.nodeTypeList.forEach((item1, index1, arr1) => {
              if (item1.id === _saveForm.type) {
                _saveForm.typeStr = item1.name;
              }
              // 更新距离数据
              this.updateDistances();
            });
            
            // 保存旧的坐标，以便需要还原時使用
            const oldLat = _saveForm.lat;
            const oldLng = _saveForm.lng;
            
            // 坐标转换逻辑：如果表单中输入或修改了WGS84经纬度，需要转换为GCJ02
            if (_saveForm.wgs84Lat && _saveForm.wgs84Lng) {
              const res = await api.postData(
                `task-server/coordinate/wgs84ToGcj02`,
                { longitude: parseFloat(_saveForm.wgs84Lng), latitude: parseFloat(_saveForm.wgs84Lat) },
                this
              );
              if (!res.success || !res.data) {
                throw new Error(langMap.coordinateConversionFailed[this.lang]);
              }
              _saveForm.lng = res.data[0];
              _saveForm.lat = res.data[1];
              _saveForm.wgs84Lng = this.roundDecimal(parseFloat(_saveForm.wgs84Lng), 7);
              _saveForm.wgs84Lat = this.roundDecimal(parseFloat(_saveForm.wgs84Lat), 7);
            } else if (!_saveForm.wgs84Lat && !_saveForm.wgs84Lng && _saveForm.lat && _saveForm.lng && _saveForm.coordinateSource === 'map') {
              // 如果是从地图拖拆来的，需要转换为WGS84
              const res = await api.postData(
                `task-server/coordinate/gcj02ToWgs84`,
                { longitude: parseFloat(_saveForm.lng), latitude: parseFloat(_saveForm.lat) },
                this
              );
              if (!res.success || !res.data) {
                throw new Error(langMap.coordinateConversionFailed[this.lang]);
              }
              _saveForm.wgs84Lng = this.roundDecimal(res.data[0], 7);
              _saveForm.wgs84Lat = this.roundDecimal(res.data[1], 7);
            }
            
            // 坐标转换不处理来源标记
            _saveForm.coordinateSource = null;
            
            if (_saveForm.id === null && _saveForm.tempId === null) {
              //新增
              if (_saveForm.tempId === null) {
                _saveForm.tempId = uuidv4();
              }
              _saveForm.pathId = this.pathId;
              // DO:插入到 倒数第二个，并更新最后一个点的排序
              if (this.insertIndex !== -1) {
                _nodeList.splice(this.insertIndex, 0, _saveForm);
                this.insertIndex = -1;
              } else {
                addNode(_nodeList, _saveForm);
              }
              // 重新排序
              _nodeList.forEach((item, index) => {
                item.nodeOrder = index + 1;
              });
              // 插入节点后，需要重新初始化地图路径以保证轻线正确
              this.$nextTick(() => {
                if (mapCase) {
                  mapCase.initPath(_nodeList);
                }
                // 更新距离数据
                this.updateDistances();
              });
            } else {
              //编辑
              this.nodeList.forEach((item, index, arr) => {
                this.saveForm.pathId = this.pathId;
                if (this.saveForm.tempId && this.saveForm.tempId !== null && this.saveForm.tempId !== '') {
                  //通过临时tempId查找
                  if (item.tempId === this.saveForm.tempId) {
                    this.$set(this.nodeList, index, this.saveForm);
                  }
                } else if (item.id === this.saveForm.id) {
                  this.$set(this.nodeList, index, this.saveForm);
                }
              });
              // 编辑完成后重新渲枣地图以保证坐标正常显示
              this.$nextTick(() => {
                if (mapCase) {
                  mapCase.initPath(this.nodeList);
                }
                // 更新距离数据
                this.updateDistances();
              });
            }
            
            this.saveModal = false;
            this.btnLoading = false;
          } catch (error) {
            // 处理错误
            console.error('保存节点失败', error);
            this.btnLoading = false;
            
            // 转换失败会导致地图上可能已经修改了坐标，需要还原
            if (_saveForm.coordinateSource === 'map') {
              // 从指定节点找到并还原坐标
              const nodeIndex = _nodeList.findIndex(n => 
                (n.tempId === _saveForm.tempId) || (n.id === _saveForm.id)
              );
              if (nodeIndex > -1 && oldLat && oldLng) {
                _nodeList[nodeIndex].lat = oldLat;
                _nodeList[nodeIndex].lng = oldLng;
                _nodeList[nodeIndex].coordinateSource = null;
                
                // 重新转换地图
                this.$nextTick(() => {
                  if (mapCase) {
                    mapCase.initPath(_nodeList);
                    this.$Notice.warning({
                      title: langMap.tip[this.lang],
                      desc: langMap.mapMarkerRestore[this.lang]
                    });
                  }
                });
              }
            }
            
            // 提示错误
            this.$Notice.error({
              title: langMap.tip[this.lang],
              desc: error.message || langMap.coordinateConversionFailed[this.lang]
            });
            // 编辑完成后重新渲枣地图以保证坐标正常显示
            this.$nextTick(() => {
              if (mapCase) {
                mapCase.initPath(this.nodeList);
              }
              // 更新距离数据
              this.updateDistances();
            });
          }
        } else {
          this.btnLoading = false;
        }
      })
    },
    cancel() {
      this.saveModal = false;
      //取消进行数据模拟置空
      this.saveForm.attrs = {clear: 'clear'};
      this.saveForm.attrs = null;
      // 清除坐标来源标记
      this.saveForm.coordinateSource = null;
    },
    //校验任务
    checkTask() {
      let check = true;
      if (this.nodeList === null || this.nodeList.length < 1) {
        this.$Notice.error({
          title: this.langMap.tip[this.lang],
          desc: this.langMap.noNodes[this.lang],
        });
        check = false;
      }

      let hasSetPoint = true;
      this.nodeList.forEach((item, index, arr) => {
        // 确保它们的序号
        item.nodeOrder = index + 1;
        if (item.lat === null || item.lat === '' || item.lng === null || item.lng === '') {
          hasSetPoint = false;
        }
        // 处理动态表单数据
        this.saveAttrsHandle(item);
      });
      if (!hasSetPoint) {
        this.$Notice.error({
          title: this.langMap.tip[this.lang],
          desc: this.langMap.noCoordinates[this.lang],
        });
        check = false;
      }
      return check;
    },
    saveAttrsHandle(item){
      if(item.attrs){
        let dynamicFormData = Object.keys(item.attrs).reduce((acc, key) => {
          const value = item.attrs[key];
          if (value != null && value !== "") {
            acc[key] = value+'';
          }
          return acc;
        }, {});
        if(JSON.stringify(dynamicFormData) === '{}'){
          dynamicFormData = null
        }
        item.attrs = dynamicFormData;
      }
    },
    //保存任务
    saveTask() {
      if (this.checkTask()) {
        this.btnLoading = true;
        api.postData("task-server/node/save", this.nodeList, this).then((res) => {
          this.btnLoading = false;
          if (res.state == 0) {
            this.$Notice.error({
              title: langMap.promptFromSystem[this.lang],
              desc: res.msg
            })
          } else {
            this.$Notice.success({
              title: langMap.promptFromSystem[this.lang],
              desc: langMap.operationSuccess[this.lang],
            });
            //关闭当前页面
            this.backPage();
          }
        })
      }
    },
    loadPath(pathId) {
      if (!pathId || pathId === null) {
        return;
      }
      this.tableLoading = true;
      api.getData('task-server/node/get/path/' + pathId).then((res) => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg,
          });
        } else {
          if (res.data && res.data.length > 0) {
            res.data.forEach((item, index, arr) => {
              item.tempId = item.id;
              item.attrs = item.attrs || null;
              this.nodeTypeList.forEach((item1, index1, arr1) => {
                if (item1.id === item.type) {
                  item.typeStr = item1.name;
                }
              });
            });
            this.nodeList = res.data;
            //初始化任务节点
            mapCase.initPath(res.data);
            // 更新距离数据
            this.updateDistances();
            // 页面加载后自动昺示第一个节点的信息
            this.$nextTick(() => {
              if (this.nodeList.length > 0) {
                this.rowClick(this.nodeList[0]);
              }
            });
          }
        }
      }).finally(() => { this.tableLoading = false });
    },
    getDic() {
      api.getData('task-server/path/get/dic', this).then((res) => {
        if (res.state == 0) {
          this.$Notice.error({
            title: langMap.tip[this.lang],
            desc: res.msg,
          });
        } else {
          this.nodeTypeList = res.data.nodeType;
        }
      })
    },
    backPage() {
      this.$emit('changePageShow', '');
    },
    async updateNodeList(nodeList) {
      // 策略调整：以本地 nodeList 为主结构，仅从地图返回的列表同步坐标
      // 这样可以防止地图组件因逻辑差异产生重复节点或打乱顺序
      let hasUpdate = false;
      let updatedNode = null; // 记录被更新的节点
      let conversionSuccess = true; // 跟踪坐标转换是否成功
      
      // 处理删除：检查本地列表中是否有节点在地图返回的列表中不存在
      const deletedNodes = [];
      this.nodeList.forEach(localNode => {
        const existsInMap = nodeList.find(n => 
          (localNode.tempId && n.tempId === localNode.tempId) || 
          (localNode.id && n.id === localNode.id)
        );
        if (!existsInMap) {
          deletedNodes.push(localNode);
        }
      });
      
      // 删除不存在的节点
      if (deletedNodes.length > 0) {
        deletedNodes.forEach(delNode => {
          const index = this.nodeList.findIndex(n => 
            (delNode.tempId && n.tempId === delNode.tempId) || 
            (delNode.id && n.id === delNode.id)
          );
          if (index > -1) {
            this.nodeList.splice(index, 1);
          }
        });
        // 重新排序
        this.nodeList.forEach((item, i) => {
          item.nodeOrder = i + 1;
        });
        hasUpdate = true;
      }
      
      // 处理坐标更新 - 使用 for...of 以正确等待异步操作
      for (const localNode of this.nodeList) {
        // 在返回的列表中查找匹配的节点 (优先匹配 tempId，其次 id)
        // 增加兜底逻辑：如果都是新节点(无id)，且名字相同，且本地无坐标，也认为是同一个（处理"标记"产生的副本）
        const match = nodeList.find(n => {
           const idMatch = (localNode.tempId && n.tempId === localNode.tempId) || (localNode.id && n.id === localNode.id);
           if (idMatch) return true;
           
           // 辅助匹配：处理地图组件可能将新标记视为新对象的情况
           if (!localNode.id && !n.id && localNode.name === n.name && !localNode.lat && n.lat) {
             return true;
           }
           return false;
        });

        if (match) {
           // 同步坐标
           if (match.lat && match.lng && (localNode.lat !== match.lat || localNode.lng !== match.lng)) {
             const oldLat = localNode.lat;
             const oldLng = localNode.lng;
             
             localNode.lat = match.lat;
             localNode.lng = match.lng;
             if (match.coordinateType) localNode.coordinateType = match.coordinateType;
             
             // 如果是地图修改坐标，需要转换为WGS84
             if (match.coordinateSource === 'map') {
               try {
                 const res = await api.postData(
                   `task-server/coordinate/gcj02ToWgs84`,
                   { longitude: parseFloat(match.lng), latitude: parseFloat(match.lat) },
                   this
                 );
                 if (!res.success || !res.data) {
                   throw new Error(langMap.coordinateConversionFailed[this.lang]);
                 }
                 localNode.wgs84Lng = res.data[0];
                 localNode.wgs84Lat = res.data[1];
                 
                 hasUpdate = true;
                 updatedNode = localNode; // 记录被更新的节点
               } catch (error) {
                 console.error('坐标转换失败', error);
                 conversionSuccess = false; // 标记转换失败
                 // 转换失败时还原坐标
                 localNode.lat = oldLat;
                 localNode.lng = oldLng;
                 
                 // 提示错误
                 this.$Notice.error({
                   title: langMap.tip[this.lang],
                   desc: langMap.coordinateConversionFailed[this.lang]
                 });
                 
                 // 需要重新渲枣地图以还原
                 this.$nextTick(() => {
                   if (mapCase) {
                     mapCase.initPath(this.nodeList);
                   }
                 });
                 break; // 跳出循环
               }
             } else {
               hasUpdate = true;
               updatedNode = localNode; // 记录被更新的节点
             }
           }
        }
      }
      
      // 仅在有控制条件下执行
      if (hasUpdate && updatedNode) {
         // 触发视图更新
         this.nodeList = [...this.nodeList];
         // 关键修复：addMarker会将新标记的点追加到地图内部列表末尾
         // 直接调用 initPath 重建（initPath 已修改为会先清空所有旧 Marker 和 Line）
         this.$nextTick(()=>{
           if (mapCase) {
             // 关键：强制按 nodeOrder 排序，确保数组物理顺序绝对正确
             const freshList = JSON.parse(JSON.stringify(this.nodeList));
             freshList.sort((a, b) => a.nodeOrder - b.nodeOrder);
             mapCase.initPath(freshList);
             // 仅在坐标转换成功时才更新距离
             if (conversionSuccess) {
               this.updateDistances();
             }
           }
         })
      } else {
         // 执行次的跋算：触发跋算
         this.updateDistances();
      }
    },
  },
  mounted() {
    this.getDic();
    //初始化地图、初始化地图组件
    this.$nextTick(this.initMap);
  }
}
</script>
<style scoped>
.leaflet {
  width: 100%;
  height: 500px;
  margin-left: 0px;
}

.nodeArea {
  width: 100%;
  height: 500px;
}

.map {
  width: 100%;
  height: calc(100%);
  z-index: 1;
}

.my-div-icon {
  background-color: transparent;
  border: 0;
}

.input-item {
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -ms-flex-align: center;
  align-items: center;
  width: 100%;
  height: 3rem;
}

.input-card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border-radius: .25rem;
  width: 22rem;
  border-width: 0;
  border-radius: 0.4rem;
  box-shadow: 0 2px 6px 0 rgba(114, 124, 245, .5);
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  -ms-flex: 1 1 auto;
  flex: 1 1 auto;
  padding: 0.75rem 1.25rem;
  font-size: 12px;
}

.custom-input-card {
  width: 18rem;
}

.custom-input-card .btn:last-child {
  margin-left: 1rem;
}

.content-window-card {
  position: relative;
  width: 23rem;
  padding: 0.75rem 0 0 1.25rem;
  box-shadow: none;
  bottom: 0;
  left: 0;
}

.content-window-card p {
  height: 2rem;
}

.des-cardTittle-box {
  display: flex;
  justify-content: space-between;
}

#myPageTop {
  position: absolute;
  top: 5px;
  right: 10px;
  background: #fff none repeat scroll 0 0;
  border: 1px solid #ccc;
  margin: 10px auto;
  padding: 6px;
  font-family: "Microsoft Yahei", "微软雅黑", "Pinghei";
  font-size: 14px;
  z-index: 10;
}

#myPageTop label {
  margin: 0 20px 0 0;
  color: #666666;
  font-weight: normal;
}

#myPageTop input {
  width: 170px;
}

#myPageTop .column2 {
  padding-left: 25px;
}

/* 自定义表格样式 */
.custom-header {
  display: flex;
  background-color: #f8f8f9;
  font-weight: bold;
  color: #515a6e;
  height: 40px;
  line-height: 40px;
  border-bottom: 1px solid #e8eaec;
}
.custom-row {
  display: flex;
  height: 48px;
  line-height: 48px;
  background-color: #fff;
  border-bottom: 1px solid #e8eaec;
  cursor: pointer;
  transition: background-color 0.2s;
}
.custom-row:hover {
  background-color: #ebf7ff;
}
.c-col-checkbox { width: 50px; text-align: center; border-right: 1px solid #e8eaec; display: flex; justify-content: center; align-items: center; }
.c-col-order { width: 60px; text-align: center; border-right: 1px solid #e8eaec; }
.c-col-name { flex: 1; padding: 0 10px; border-right: 1px solid #e8eaec; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.c-col-type { width: 130px; padding: 0 10px; border-right: 1px solid #e8eaec; }
.c-col-oper { width: 140px; text-align: center; display: flex; justify-content: center; align-items: center;}

.no-data {
  text-align: center;
  padding: 20px;
  color: #999;
}

/* 插入条样式 */
.insert-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 10px; /* 默认很细 */
  cursor: pointer;
  position: relative;
  transition: all 0.2s;
  gap: 0;
}
.insert-bar:hover {
  height: 32px; /* 悬停展开 */
}
.insert-line {
  flex: 1;
  height: 1px;
  background-color: transparent;
  border-top: 1px dashed #2d8cf0;
  opacity: 0;
  transition: opacity 0.2s;
  /* 仅当insert-content不是可见时才昺示（速度优化） */
}
.insert-bar:hover .insert-line {
  opacity: 0.5;
}
.insert-btn {
  font-size: 12px;
  color: #2d8cf0;
  background: #fff;
  padding: 0 10px;
  border: 1px dashed #2d8cf0;
  border-radius: 10px;
  opacity: 0;
  transform: scale(0.8);
  transition: all 0.2s;
  white-space: nowrap;
}
/* 悬停時昺示 */
.insert-bar:hover .insert-btn {
  opacity: 1;
  transform: scale(1);
}

/* 距离显示样式 */
.insert-content {
  display: flex;
  align-items: center;
  gap: 16px;
  background: transparent;
  padding: 0 12px;
  z-index: 10;
}
.distance-display {
  display: flex;
  align-items: center;
  font-size: 12px;
  opacity: 0;
  transition: opacity 0.2s;
  background: #fff;
  padding: 2px 8px;
  border-radius: 2px;
}
.insert-bar:hover .distance-display {
  opacity: 1;
}
.distance-text-inline {
  color: #2d8cf0;
  font-weight: 500;
  white-space: nowrap;
}

/deep/.ivu-col-span-12{
  display: inline-block;
  width: 49%;
}
</style>
